import { formatCpDate } from '@cp-shared-19/common-utilities';
import { DATE_FORMAT } from 'cpes-common';

export type FormValues = {
    futureQuoteDate?: string;
};

export const getInitialValues = (): FormValues => ({
    futureQuoteDate: formatCpDate()
        .add(1, 'days')
        .format(DATE_FORMAT),
});
